import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { SuperSMSCertifiedConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';

export class SuperSMSCertifiedNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: SuperSMSCertifiedConfig) {
    super(id, NodeType.SuperSendCertifiedSMS, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['copyIds'].length == 0;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  initNodeConfig() {
    (this.config as SuperSMSCertifiedConfig).copyIds = [];
    (this.config as SuperSMSCertifiedConfig).certified = true;
    (this.config as SuperSMSCertifiedConfig).super = true;
    (this.config as SuperSMSCertifiedConfig).sendToAllContacts = false;
    (this.config as SuperSMSCertifiedConfig).expirationDays = 180;
    (this.config as SuperSMSCertifiedConfig).expirationAt = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.config['copyIds'] == null) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_COPY_IDS, {
        nodoType: 'SMS Certificado IA',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    return errors;
  }
}
